<template>
  <div id="shop-list">
    <!-- 顶部导航栏 -->
    <div class="header-top">
      <div class="mall-top">
        <span class="shop-name" v-if="$route.query.shopId">{{ shopName }}</span>
        <el-menu
          :default-active="searchForm.categoryId"
          class="nav-bar"
          mode="horizontal"
          @select="handleSelect"
        >
          <template v-for="(item, index) in shoppingType">
            <el-menu-item :key="item.index" :index="String(item.id)">
              {{ item.value }}
            </el-menu-item>
          </template>
        </el-menu>
        <div class="ipt">
          <el-input
            placeholder="搜索农资产品..."
            v-model="searchForm.keyword"
            @change="changeValue()"
            class="search-input"
          >
            <template #append>
              <el-button icon="el-icon-search"></el-button>
            </template>
          </el-input>
        </div>
        <el-button type="primary" class="map-btn" @click="toMap()"
          >商家地图</el-button
        >
      </div>
    </div>

    <!-- 筛选栏 -->
    <div class="search-box">
      <div class="filter-bar">
        <div class="filter-left">
          <span class="el-dropdown-link">排序：</span>
          <el-dropdown
            @command="(cmd) => handleSortCommand('price', cmd)"
            class="sort-dropdown"
          >
            <span class="el-dropdown-link">
              价格<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item
                  v-for="(item, index) in options"
                  :key="index"
                  :command="item.value"
                  >{{ item.name }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </template>
          </el-dropdown>

          <span class="sort-gap"></span>

          <el-dropdown
            @command="(cmd) => handleSortCommand('soldNum', cmd)"
            class="sort-dropdown"
          >
            <span class="el-dropdown-link">
              销量<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item
                  v-for="(item, index) in options"
                  :key="index"
                  :command="item.value"
                  >{{ item.name }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </template>
          </el-dropdown>

          <span class="sort-gap"></span>

          <el-dropdown
            @command="(cmd) => handleSortCommand('averageScore', cmd)"
            class="sort-dropdown"
          >
            <span class="el-dropdown-link">
              好评<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item
                  v-for="(item, index) in options"
                  :key="index"
                  :command="item.value"
                  >{{ item.name }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </template>
          </el-dropdown>

          <el-button type="text" class="clear-btn" @click="clearFilters"
            >清除所有</el-button
          >
        </div>
      </div>
    </div>

    <!-- 商品统计 -->
    <div class="allShopNum">
      <h3>共{{ total }}件商品</h3>
    </div>

    <!-- 商品列表 -->
    <div
      class="product-list"
      v-infinite-scroll="loadMore"
      :infinite-scroll-disabled="loading || noMore"
      infinite-scroll-distance="80"
    >
      <div
        v-for="(product, idx) in productList"
        :key="product.id + '-' + idx"
        class="product-item"
        @click="detail(product.id)"
      >
        <img :src="product.img2" alt="" class="product-image" />
        <div class="product-info">
          <h3 class="product-title">{{ product.name }}</h3>
          <p class="product-desc">{{ product.brand }}</p>
          <div class="product-meta">
            <el-rate
              v-model="product.averageScore"
              disabled
              show-score
              text-color="#ff9900"
            />
            <span class="reviews">({{ product.soldNum }})</span>
          </div>
          <div class="product-price">
            <span class="price">¥{{ product.price }}</span>
            <span class="old-price" v-if="product.oldPrice"
              >¥{{ product.oldPrice }}</span
            >
          </div>
        </div>
      </div>
      <div v-if="loading" class="loading-text">加载中...</div>
      <div v-if="noMore" class="no-more-text">没有更多数据了</div>
    </div>

    <!-- 悬浮回到顶部按钮 -->
    <el-button
      class="back-top-btn"
      circle
      icon="el-icon-arrow-up"
      @click="scrollToTop"
    />
  </div>
</template>

<script>
import { appletPcPageList } from "@/api/sjzx";
import { tree } from "@/api/sjzx";
export default {
  data() {
    return {
      shoppingType: [], // 商品类别列表
      baseUrl: window.globalUrl.HOME_API, // 图片等资源基础URL
      searchForm: {
        categoryId: "", // 分类ID
        keyword: "", // 搜索关键字
        orderBy: "", //排序类型
        orderType: "", //排序方式
        pageNum: 1, // 当前页码
        pageSize: 10, // 每页数量
        shopId: "", //商家id
      },
      options: [
        // 排序选项
        { name: "从高到低", value: "desc" },
        { name: "从低到高", value: "asc" },
      ],
      productList: [], // 商品列表
      total: 0, // 商品总数
      loading: false, // 加载状态
      noMore: false, // 是否没有更多数据
      filterFields: ["price", "soldNum", "averageScore"], // 可筛选字段
      shopName: "", // 商铺名称
      isLoadingFirstPage: false, // 首页加载中标记
      debounceTimer: null, // 防抖计时器
    };
  },
  mounted() {
    // 1. 读取路由参数并赋值
    this.searchForm.shopId = this.$route.query.shopId || "";
    // 2. 初始化加载商品和分类列表，隐藏底部footer
    this.getAppletPcPageList();
    this.getTreeList();
    const footer = document.querySelector(".footer");
    if (footer) footer.style.display = "none";
  },
  methods: {
    // 处理排序命令，重置筛选并设置排序字段
    handleSortCommand(type, command) {
      this.searchForm.orderBy = type;
      this.searchForm.orderType = command;
      this.searchForm.pageNum = 1; // 重置页码
      this.searchForm.keyword = ""; // 清除搜索词
      this.debouncedSearch();
    },
    // 处理分类切换，重置筛选并设置分类ID
    handleSelect(key) {
      this.searchForm.categoryId = key;
      this.searchForm.pageNum = 1; // 重置页码
      this.searchForm.keyword = ""; // 清除搜索词
      this.searchForm.orderBy = ""; // 清除排序
      this.searchForm.orderType = ""; // 清除排序方式
      this.debouncedSearch();
    },
    // 搜索框内容变化，重置页码并重新加载
    changeValue() {
      this.searchForm.pageNum = 1;
      this.debouncedSearch();
    },
    // 防抖搜索方法
    debouncedSearch() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.getAppletPcPageList();
      }, 300);
    },
    // 格式化商品列表数据，处理图片和库存状态
    formatProductList(arr) {
      if (!arr) return [];
      return arr.map((item) => ({
        ...item,
        // 处理图片字段，拼接完整URL
        img2:
          item.img &&
          !Array.isArray(item.img) &&
          item.img.length > 0 &&
          JSON.parse(item.img)[0]
            ? this.baseUrl +
              "admin/file/get?ossFilePath=" +
              JSON.parse(item.img)[0].url
            : "",
        // // 库存状态文本
        // stockstatus2: item.stockStatus == 0 ? '已售罄' : item.stockStatus == 1 ? '库存紧张' : item.stockStatus == 2 ? '正常' : '',
        // // 库存状态类型（用于样式）
        // statusType2: item.stockStatus == '0' ? 'danger' : item.stockStatus == 1 ? 'warning' : item.stockStatus == 2 ? 'success' : ''
      }));
    },
    // 跳转到商户地图页面
    toMap() {
      this.$router.push({ name: "agriService" });
    },
    // 跳转到商品详情页
    detail(id) {
      this.$router.push({ name: "shopDetail", query: { id } });
    },
    // 获取商品分页列表，支持筛选和排序
    async getAppletPcPageList() {
      try {
        const isFirstPage = this.searchForm.pageNum === 1;

        // 首页加载或二次加载时，防止重复请求
        if (isFirstPage) {
          this.isLoadingFirstPage = true;
        }

        // 总的加载状态标记
        this.loading = true;
        const params = { ...this.searchForm };
        const res = await appletPcPageList(params);

        if (res.code === 0) {
          if (isFirstPage) {
            // 首次加载或重置时覆盖
            this.productList = this.formatProductList(res.data.records) || [];
            this.noMore = false;
          } else {
            // 加载更多时追加
            const newData = this.formatProductList(res.data.records);
            this.productList = this.productList.concat(newData);
          }

          this.total = res.data.total;

          // 判断是否已加载全部 - 基于返回的记录数或总数
          const currentLoadedCount = this.productList.length;
          if (
            !res.data.records ||
            res.data.records.length < this.searchForm.pageSize ||
            currentLoadedCount >= this.total
          ) {
            this.noMore = true;
          }

          // 商品列表加载后赋值shopName
          this.shopName =
            this.productList[0] && this.productList[0].shopName
              ? this.productList[0].shopName
              : "";
        }
      } catch (e) {
        this.$message && this.$message.error("加载商品失败");
        // 只在首页加载失败时标记为无更多，避免无限重试
        if (this.searchForm.pageNum === 1) {
          this.noMore = false;
        }
      } finally {
        this.loading = false;
        this.isLoadingFirstPage = false;
      }
    },
    // 下拉加载更多商品
    async loadMore() {
      // 如果正在加载、没有更多数据、或首页还在加载中，则不继续加载
      if (this.loading || this.noMore || this.isLoadingFirstPage) {
        return;
      }

      this.searchForm.pageNum += 1;
      await this.getAppletPcPageList();
    },
    // 获取商品分类列表
    async getTreeList() {
      try {
        const res = await tree({
          // shopId: this.searchForm.shopId || '',
          level: "2",
        });
        this.shoppingType = res.data || [];
      } catch (e) {
        this.$message && this.$message.error("加载分类失败");
      }
    },
    // 重置所有筛选和分页参数
    resetSearchForm(keepCategoryId = false) {
      const oldCategoryId = this.searchForm.categoryId;
      const oldShopId = this.searchForm.shopId; // 始终保留 shopId

      this.searchForm = {
        categoryId: keepCategoryId ? oldCategoryId : "",
        keyword: "",
        orderBy: "", // 排序类型
        orderType: "", // 排序方式
        pageNum: 1,
        pageSize: 10,
        shopId: oldShopId, // 恢复 shopId
      };
      this.productList = [];
      this.noMore = false;
    },
    // 清除所有筛选项并重新加载
    clearFilters() {
      // 完全重置，只保留 shopId
      this.searchForm.categoryId = "";
      this.searchForm.keyword = "";
      this.searchForm.orderBy = "";
      this.searchForm.orderType = "";
      this.searchForm.pageNum = 1;
      this.productList = [];
      this.noMore = false;
      this.getAppletPcPageList();
    },
    // 回到顶部按钮方法
    scrollToTop() {
      const el = document.querySelector(".product-list");
      if (el) el.scrollTo({ top: 0, behavior: "smooth" });
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
  beforeUnmount() {
    // 销毁前清理定时器和关闭WebSocket连接
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    // 恢复footer显示
    const footer = document.querySelector(".footer");
    if (footer) footer.style.display = "";
  },
};
</script>

<style scoped>
.mall-top {
  width: auto;
  background: white;
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.08);
  position: relative;
}

.ipt {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 350px;

  .el-input-group__append {
    background-color: white;
  }

  .el-select .el-input {
    width: 180px;
  }

  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }
}

.search-box {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 20px 0px;
  background-color: #f2f2f2 !important;
  .filter-bar {
    width: 95%;
    background-color: white;
    border-radius: 10px;
  }
}

.product-list {
  display: flex;
  /* height: 620px; */
  background-color: red;
  overflow-y: auto;
  flex-wrap: wrap;
  /* gap: 28px 2.5%; */
  /* 行间距更大，列间距自适应 */
  padding: 32px 40px 40px 40px;
  background: #f7f8fa;
  /* min-height: 600px; */
  justify-content: flex-start;
}

.product-item {
  width: 22%;
  margin: 20px 20px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  padding: 0 0 18px 0;
  transition: box-shadow 0.25s, transform 0.18s;
  display: flex;
  flex-direction: column;
  margin-bottom: 18px;
  height: 350px;
  cursor: pointer;
  border: 1px solid #f0f0f0;
}

.product-item:hover {
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.16);
  transform: translateY(-8px) scale(1.025);
  border-color: #e6e6e6;
}

.product-image {
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 16px 16px 0 0;
  background: #f5f5f5;
}

.product-info {
  padding: 14px 18px 0 18px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.product-title {
  font-size: 16px;
  font-weight: 700;
  color: #222;
  margin-bottom: 4px;
  line-height: 1.3;
  min-height: 38px;
}

.product-desc {
  font-size: 13px;
  color: #888;
  margin-bottom: 8px;
  min-height: 18px;
}

.product-meta {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.reviews {
  color: #b1b1b1;
  font-size: 13px;
  margin-left: 8px;
}

.product-price {
  margin-top: 6px;
  display: flex;
  align-items: baseline;
}

.price {
  color: #f56c6c;
  font-weight: bold;
  font-size: 20px;
  margin-right: 8px;
}

.old-price {
  color: #bbb;
  text-decoration: line-through;
  font-size: 14px;
  margin-left: 8px;
}

.header-top {
  width: 100%;
  background: #fff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.06);
  border-bottom: 1px solid #f0f0f0;
  position: sticky;
  top: 0;
  z-index: 10;
}

.mall-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px;
  height: 64px;
}

.nav-bar {
  flex: 1;
  display: flex;
  justify-content: flex-start;
  width: 408px;
  height: 48px; /* 固定高度，和el-menu默认高度一致 */
  line-height: 48px; /* 保证菜单项垂直居中 */
  overflow: visible; /* 允许下拉菜单溢出显示 */
  background: transparent;
  border-bottom: none;
}

.ipt {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 350px;
}

.search-input {
  width: 100%;
}

.map-btn {
  margin-left: 10px;
  z-index: 1;
}

.search-box {
  width: 100%;
  display: flex;
  justify-content: center;
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
}

.filter-bar {
  width: 80%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 0 10px 0;
}

.filter-left {
  display: flex;
  align-items: center;
  margin-left: 30px;
}

.clear-btn {
  margin-left: 10px;
}

.filter-right {
  display: flex;
  align-items: center;
}

.allShopNum {
  margin: 20px 0 0 40px;
}

.allShopNum h3 {
  font-size: 20px;
  font-weight: 500;
  color: #333;
}

.back-top-btn {
  position: fixed;
  right: 36px;
  bottom: 36px;
  z-index: 100;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  border: none;
}

.loading-text {
  text-align: center;
  padding: 10px;
  color: #606266;
  width: 100%;
  flex-basis: 100%;
}

.no-more-text {
  text-align: center;
  padding: 10px;
  color: #909399;
  width: 100%;
  flex-basis: 100%;
}

.sort-gap {
  display: inline-block;
  width: 18px;
  height: 1px;
}

.shop-name {
  font-size: 18px;
  font-weight: bold;
  margin-right: 32px;
  color: #333;
  white-space: nowrap;
}

@media (max-width: 1200px) {
  .product-item {
    width: 30%;
  }
}

@media (max-width: 900px) {
  .product-item {
    width: 46%;
  }
}

@media (max-width: 600px) {
  .product-item {
    width: 98%;
    min-width: 0;
  }
}
</style>
